import { render, staticRenderFns } from "./ColorRound.vue?vue&type=template&id=84e71ac4&"
import script from "./ColorRound.vue?vue&type=script&lang=js&"
export * from "./ColorRound.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports